import { initExploreGroups } from '~/explore/groups';

initExploreGroups();
